// modules
import { addModal } from 'weblite-web-modal-viewer'
import { CreateStoryModal } from './create-story'

const COMPONENT_ID = 'createStoryModal'

export const showCreateStoryModal = (
  props: Parameters<typeof CreateStoryModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: CreateStoryModal,
  },
}
